import React from "react";
import { StrictMode } from "react";
import { ApolloProvider } from "@apollo/client/react";
import { client } from "../gqlClient";
import App from "./App";
import { StyledEngineProvider, ThemeProvider } from "@mui/material/styles";
import theme from "./theme";
import Ribbon from "./common/Ribbon/Ribbon";

const Main: React.FC = () => (
  //injectFirst https://mui.com/material-ui/guides/interoperability/
  <ApolloProvider client={client}>
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <StrictMode>
          <Ribbon />
          <App />
        </StrictMode>
      </ThemeProvider>
    </StyledEngineProvider>
  </ApolloProvider>
);

export default Main;
